import { BackendRoute } from '../../../../config/index';
import { QueryKey } from '../../../../constants/query-key.const';
import { HttpException } from '../../../../exceptions/index';
import { useAppMutation } from '../../../../hooks/use-app-mutation.hook';
import ApiService from '../../../../services/api-service.util';

type RecipientViewResponse = {
  url: string;
};

export const useSignatureRecipientView = (): {
  fetchRecipientViewUrl: (signatureId: string) => Promise<RecipientViewResponse>;
} => {
  const { mutateAsync: fetchRecipientViewUrl } = useAppMutation<
    RecipientViewResponse,
    HttpException,
    string
  >([QueryKey.SIGNATURE_RECIPIENT_VIEW], {
    mutationFn: (signatureId: string) =>
      ApiService.post<RecipientViewResponse>(
        { endpoint: BackendRoute.SIGNATURES, routePath: [signatureId, 'recipient-view'] },
        { body: {} },
      ),
  });

  return { fetchRecipientViewUrl };
};
